import { createContext, useState, useEffect } from 'react'
import { useIsAuthenticated } from '@azure/msal-react';
import { RolesConstants } from '../constants/roles';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const HOMEOWNER_CSS_CLASS = `role-${RolesConstants.HOMEOWNER}`;
  const CONTRACTOR_CSS_CLASS = `role-${RolesConstants.CONTRACTOR}`;

  const isAuthenticated = useIsAuthenticated();

  const getSessionRoles = () => {
    const sessionUser = sessionStorage.getItem('user');

    return sessionUser?.roles || [];
  }

  let compareRoles = (
      newRoles,
      currentRoles
  ) => {
      return (
          newRoles?.length === currentRoles?.length &&
          newRoles.every((newRole) =>
              currentRoles.some(
                  (currentRole) =>
                      newRole.id === currentRole.id
              )
          )
      );
  };

  const [roles, setRoles] = useState(getSessionRoles());
  const [user, setUser] = useState(
    sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {}
  );

  const isHomeowner = () => {
    return !isContractor();
  }

  const isContractor = () => {
    let isContractor = false;
    if (roles) {
      roles.forEach(role => {
        if (role.code === RolesConstants.CONTRACTOR) {
          isContractor = true;
        }
      });
    }
    
    return isAuthenticated && isContractor;
  }

  useEffect(() => {
    sessionStorage.setItem("user", JSON.stringify(user));
    const newRoles = user?.roles || [];

    if (!compareRoles(newRoles, roles)) {
      setRoles(newRoles);
    }
  }, [user, roles]);

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (user) {
      setUser(JSON.parse(user));
    }
  }, []);

  const roleCssClass = isHomeowner()
    ? HOMEOWNER_CSS_CLASS
    : isContractor() ? CONTRACTOR_CSS_CLASS : '';

  return (
    <UserContext.Provider
      value={{
        roles,
        user,
        setUser,
        isHomeowner,
        isContractor
      }}
    >
      <div className={`app-role-main-container ${roleCssClass}`}>
        {children}
      </div>
    </UserContext.Provider>
  );
};
